<template>
  <div class="w1200">
    <el-breadcrumb separator="/" class="breadcrumb" v-if="isList">
      <el-breadcrumb-item v-for="(b, i) in breadcrumb1" :key="'breadcrumb' + i"><span @click="goResource(i)">{{ b }}</span></el-breadcrumb-item>
    </el-breadcrumb>
    <div class="bg1 fl w240" style="position: absolute; top: 44px; height: calc(100% - 57px); overflow: auto">
      <div class="hd ys4">
        <h3 v-if="isList">{{ breadcrumb1[1] }}资源</h3>
        <div class="tag">
          <el-tag v-for="(b, i) in breadcrumb1.slice(2, breadcrumb1.length)" :key="'mlbq' + i" @click="goResource(i + 1)">{{ b }}<i class="el-icon-close"></i>
          </el-tag>
        </div>
        <el-tree v-if="treeShow" :props="defaultProps" :data="tree" @node-click="treeClick" highlight-current><span class="span-ellipsis" slot-scope="{ node }">
            <span :title="node.label">{{ node.label }}</span></span></el-tree>
        <span v-else>暂无数据</span>
      </div>
    </div>
    <div class="bg fr w940">
      <el-form ref="form" :model="search" label-width="120px" size="small">
        <el-form-item label="视频名称：">
          <el-input v-model="search.resourceName" style="width: 250px" placeholder="请输入搜索视频名称"></el-input>
        </el-form-item>
        <el-form-item label="共享时间：">
          <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                          @change="handleSearchDateChange"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData()">查询</el-button>
          <el-button plain @click="
              search = {
                resourceName: '',
                orgName: '',
                beginDate: '',
                endDate: '',
              };dateRange = null
            ">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="bg fr w940">
      <div style=""></div>
      <el-radio-group v-model="sortOrder" @change="getData()" size="small">
        <el-radio-button label="最新">最新<i class="el-icon-bottom"></i></el-radio-button>
        <el-radio-button label="浏览量">浏览量<i class="el-icon-bottom"></i></el-radio-button>
        <el-radio-button label="收藏量">收藏量<i class="el-icon-bottom"></i></el-radio-button>
      </el-radio-group>
      <el-divider style="margin-top: 10px"></el-divider>
      <div style="min-height: 520px">
        <ul class="vid_box" v-if="data.length > 0">
          <li class="v_b_item" v-for="(item) in data" :key="item.resourceId">
            <div class="v_b_img" @click="yulan(item, '',false,true)">
              <el-image class="b_img" fit="cover" :src="item.coverUrl?uploadUrl+item.coverUrl:require('@/assets/img/vedioCover.png')"></el-image>
              <div class="b_overlay">
                <i class="el-icon-video-play b_icon"></i>
              </div>
            </div>
            <p class="v_b_title" @click="yulan(item, '',false,true)"><span class="v_b_t">{{item.resourceName}}</span>
              <!-- <span class="b_size">2G</span> -->
            </p>
            <p class="v_b_time" :title="item.createTime">共享时间: {{item.createTime}}</p>
            <div class="v_b_menu">
              <p class="b_m_p" @click="handleDownload(item)">
                <i class="el-icon-view m_p_icon"></i>
                <span>{{item.downloadNumber?item.downloadNumber:0}}</span>
              </p>
              <p class="b_m_p " @click="handleFavorite(item)">
                <i :class="[item.isFavorite=='Y'?'el-icon-star-on':'el-icon-star-off' ,'m_p_icon']"></i>
                <span>{{item.favoriteNumber?item.favoriteNumber:0}}</span>
              </p>
              <p class="b_m_p " @click="handlerTranspond(item)">
                <i class="el-icon-share m_p_icon"></i>
                <span>{{item.forwardNumber?item.forwardNumber:0}}</span>
              </p>
            </div>
          </li>
          <!-- <li v-for="(d, i) in data" :key="i">
            <div class="icon">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#icontbd' + d.fileType"></use>
              </svg>
              <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                >- {{ d.filePage }}页 -</em
              >
            </div>
            <div class="title">
              <h5 @click="yulan(d, 1)">{{ d.resourceName }}</h5>
              <span class="catalog">
                <i class="ka">{{ d.resourceTypeName }}</i>
                <i v-if="d.versionName">{{ d.versionName }}</i>
                <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
              </span>
              <div>
                <span class="attribute">时间：{{ d.createTime.split(" ")[0] }}</span>
                <span class="attribute">下载量：{{ d.downloadNumber }}</span>
                <span class="attribute">收藏量：{{ d.favoriteNumber }}</span>
                <span class="attribute">浏览量：{{ d.visitedNumber }}</span>
                <span class="attribute">大小：{{ unit(d.fileSize) }}</span>
              </div>

              <span class="attribute">学校：{{ d.schoolName }}</span>
              <span class="attribute">作者：{{ d.createUserName }}</span>
            </div>
            <div class="operate">
              <el-button type="primary" size="mini" @click="downLoad(d, 1)"
                >下载</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="cancelShare(d.resourceId)"
                v-if="
                  userModule.roles.filter((el) => el.id == 'AreaManager').length > 0 ||
                  userModule.roles.filter((el) => el.id == 'Auditor').length > 0
                "
                >取消共享</el-button
              >
              <el-button
                v-if="d.isFavorite == 'Y'"
                type="text"
                size="mini"
                style="padding-top: 0"
                @click="favorite(d)"
                >收藏</el-button
              >
            </div>
          </li> -->
        </ul>
        <div class="unusual" v-else><span class="pt320">暂无内容</span></div>
        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" background layout="total, sizes, prev, pager, next, jumper"
                       :total="pages.pageAll" :page-size="pages.pageSize"></el-pagination>
      </div>
    </div>
    <div class="cl"></div>
    <!-- <form id='downLoadForm' style='display:none' method='post' action='http://cssz.hwxxkj.com:4283/uploader1/DownloadFile<input type='hidden' name='token' value='Y900VF33veQcMCNwTdeiBXjFNIe0vQlG'><input type='hidden' name='clientId' value='9303800555'><input type='hidden' name='Path' value='/uploader1/9303800555/2020/11/12/d10c6921a4fe471e8f9218a2a6a93172/图片.jpg'></form> -->
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import link from "../../mixins/link";
import yulan from "../../mixins/yulan";
import downLoad from "../../mixins/downLoad";
export default {
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      dateRange: null,
      search: {
        resourceName: "",
        orgName: "",
        beginDate: "",
        endDate: "",
      },
      resourceTypeData: [],
      fileTypeData: [],
      yearData: [],
      sortOrder: "最新",
      data: [],
      treeShow: false,
      clickData: {},
      breadcrumb1: [],
      previewUrl: "",
      uploadUrl: "",
      tree: [],
      pages: {
        pageIndex: 1,
        pageAll: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapState(["userModule"]),
  },
  mixins: [link, yulan, downLoad],
  props: {
    sectionData: { type: Array },
    breadcrumb: { type: Array },
    activeName: { type: String },
    breadcrumbData: { type: Object },
    init1: { type: Number },
    isList: { type: Boolean, default: true },
    searchName: { type: String, default: "" },
    searchTypeId: { type: String, default: "" },
  },
  watch: {
    init1: {
      handler(n, o) {
        console.log(n);
        if (n != 0) {
          this.init();
        }
        // this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    handleDownload(data) {
      this.$ajax
        .post("/server/third/resource/download", {
          resourceId: data.resourceId,
        })
        .then((res) => {
          this.getData();
          // this.downloadFile(data.fileUrl, data.resourceName);
          const a = document.createElement("a");
          a.setAttribute("href", this.uploadUrl + data.fileUrl);
          a.setAttribute("download", data.resourceName);
          a.setAttribute("target", "_blank");
          a.click();
        });
    },
    handleFavorite(data) {
      if (data.isFavorite == "Y") {
        this.$message({
          message: "已收藏",
          type: "warning",
        });
        return;
      }
      this.$ajax
        .post("/server/third/resource/favorite", {
          resourceId: data.resourceId,
        })
        .then((res) => {
          this.getData();
          this.$message({
            message: "收藏成功",
            type: "success",
          });
        });
    },
    handlerTranspond(data) {
      this.$ajax
        .post("/server/third/resource/forward", {
          resourceId: data.resourceId,
        })
        .then((res) => {
          let routerData = this.$router.resolve({
            name: "preview",
            params: {
              watchType: 5,
              fileUrl: this.uploadUrl + data.fileUrl,
            },
          });
          let text = window.location.host + routerData.href;
          if (navigator.clipboard) {
            // clipboard api 复制
            navigator.clipboard.writeText(text);
          } else {
            var textarea = document.createElement("textarea");
            document.body.appendChild(textarea);
            // 隐藏此输入框
            textarea.style.position = "fixed";
            textarea.style.clip = "rect(0 0 0 0)";
            textarea.style.top = "10px";
            // 赋值
            textarea.value = text;
            // 选中
            textarea.select();
            // 复制
            document.execCommand("copy", true);
            // 移除输入框
            document.body.removeChild(textarea);
          }
          this.$message({
            message: "已复制地址到剪贴板",
            type: "success",
          });
          this.getData();
        });
    },
    handleSearchDateChange(val, a) {
      if (val && val.length) {
        this.search.beginDate = val[0];
        this.search.endDate = val[1];
      }
    },
    handleSizeChange(v) {
      this.pages.pageIndex = 1;
      this.pages.pageSize = v;
      this.getData(1, v);
    },
    // 分页页码变动
    handleCurrentChange(v) {
      this.pages.pageIndex = v;
      this.getData(v);
    },
    search1() {
      this.search.resourceName = this.searchName;
      this.search.resourceTypeId = this.searchTypeId;
      this.getData();
    },
    init() {
      this.sortOrder = this.$route.params.sortOrder
        ? this.$route.params.sortOrder
        : "最新";
      this.search.resourceTypeId = this.$route.params.resourceTypeId
        ? this.$route.params.resourceTypeId
        : "";
      this.search.resourceName = this.$route.params.resourceName
        ? this.$route.params.resourceName
        : "";
      if (
        this.$route.params.sectionId &&
        this.$route.params.subjectId &&
        this.$route.params.sectionName &&
        this.$route.params.subjectName
      ) {
        this.breadcrumb1 = [
          "资源平台",
          this.$route.params.sectionName + this.$route.params.subjectName,
        ];
        this.clickData = {
          sectionId: this.$route.params.sectionId,
          sectionName: this.$route.params.sectionName,
          subjectId: this.$route.params.subjectId,
          subjectName: this.$route.params.subjectName,
        };
      } else {
        this.breadcrumb1 = this.breadcrumb;
        this.clickData = this.breadcrumbData;
      }

      this.getSearch();
      this.getData();
      this.previewUrl = window.sessionStorage.getItem("previewUrl");
      this.uploadUrl = window.sessionStorage.getItem("fileJavaServerUrl");
      this.tree = JSON.parse(window.sessionStorage.getItem("sectionData"));
      if (this.clickData.sectionId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.sectionId
        )[0].children;
      }
      if (this.clickData.subjectId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.subjectId
        )[0].children;
      }
      if (this.clickData.versionId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.versionId
        )[0].children;
      }
      if (this.clickData.volumeId) {
        this.tree = this.tree.filter(
          (el) => el.id == this.clickData.volumeId
        )[0].children;
      }
      setTimeout(() => {
        this.treeShow = true;
      }, 10);
    },
    treeClick(d, n, a) {
      this.clickData = n.data;
      this.clickData.relationDataId = n.data.dataId;
      // this.clickData.volumeId = n.data.dataId;
      let section = this.sectionData.filter(
        (el) => el.id == n.data.sectionId
      )[0];
      let subject = section.children.filter(
        (el) => el.id == n.data.subjectId
      )[0];
      if (n.data.type == "chapter") {
        if (this.breadcrumb1.length + n.level - 4 == 1) {
          this.clickData.firstChapterId = n.data.id;
        } else if (this.breadcrumb1.length + n.level - 4 == 2) {
          this.clickData.firstChapterId = n.parent.data.id;
          this.clickData.secondChapterId = n.data.id;
        } else if (this.breadcrumb1.length + n.level - 4 == 3) {
          this.clickData.firstChapterId = n.parent.parent.data.id;
          this.clickData.secondChapterId = n.parent.data.id;
          this.clickData.thirdChapterId = n.data.id;
        } else if (this.breadcrumb1.length + n.level - 4 == 4) {
          this.clickData.firstChapterId = n.parent.parent.parent.data.id;
          this.clickData.secondChapterId = n.parent.parent.data.id;
          this.clickData.thirdChapterId = n.parent.data.id;
          this.clickData.fourthChapterId = n.data.id;
        }
        this.getData();
        return false;
      }
      // this.getData();
      // if (n.data.leaf) {
      //   return false;
      // }

      if (n.data.type == "version") {
        this.treeShow = false;
        window.sessionStorage.setItem(
          "currentDirectory",
          JSON.stringify({
            sectionId: n.data.sectionId,
            sectionName: section.label,
            subjectId: n.data.subjectId,
            subjectName: subject.label,
            versionId: n.data.versionId,
            versionName: n.data.label,
            gradeId: "",
            volumeId: "",
            relationDataId: "",
            chapterId: "",
          })
        );
        window.sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify([
            "资源平台",
            section.label + subject.label,
            n.data.label,
          ])
        );
        this.$emit("replace");
      } else if (n.data.type == "volume") {
        this.treeShow = false;
        let c =
          this.breadcrumb1.length == 2
            ? n.parent.data.label
            : this.breadcrumb1[2];
        window.sessionStorage.setItem(
          "currentDirectory",
          JSON.stringify({
            sectionId: n.data.sectionId,
            sectionName: section.label,
            subjectId: n.data.subjectId,
            subjectName: subject.label,
            versionId: n.data.versionId,
            versionName: c,
            gradeId: "",
            volumeId: n.data.id,
            volumeName: n.data.label,
            relationDataId: "",
            chapterId: "",
          })
        );
        window.sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify([
            "资源平台",
            section.label + subject.label,
            c,
            n.data.label,
          ])
        );
        this.$emit("replace");
      }
    },
    goResource(v) {
      let a = {
        sectionId: "",
        sectionName: "",
        subjectId: "",
        subjectName: "",
        versionId: "",
        versionName: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        chapterId: "",
      };
      let b = [];
      if (v == 0) {
        let c = JSON.parse(window.sessionStorage.getItem("sectionData"));
        a.sectionId = c[0].id;
        a.sectionName = c[0].label;
        a.subjectId = c[0].children[0].label;
        a.subjectName = c[0].children[0].label;
        this.$router.push({ name: "IndexPage" });
        window.sessionStorage.setItem("currentDirectory", JSON.stringify(a));
        window.sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify(["资源中心", a.sectionName + a.subjectName])
        );
        return false;
      }
      if (v > 0) {
        a.sectionId = this.breadcrumbData.sectionId;
        a.sectionName = this.breadcrumbData.sectionName;
        a.subjectId = this.breadcrumbData.subjectId;
        a.subjectName = this.breadcrumbData.subjectName;
        b = ["资源中心", a.sectionName + a.subjectName];
      }
      if (v > 1) {
        a.versionId = this.breadcrumbData.versionId;
        a.versionName = this.breadcrumbData.versionName;
        b = ["资源中心", a.sectionName + a.subjectName, a.versionName];
      }
      if (v > 2) {
        a.volumeId = this.breadcrumbData.volumeId;
        a.volumeName = this.breadcrumbData.volumeName;
        b = [
          "资源中心",
          a.sectionName + a.subjectName,
          a.versionName,
          a.volumeName,
        ];
      }
      if (v > 3) {
        a.chapterId = this.breadcrumbData.chapterId;
        a.chapterName = this.breadcrumbData.chapterName;
        b = [
          "资源中心",
          a.sectionName + a.subjectName,
          a.versionName,
          a.volumeName,
          a.chapterName,
        ];
      }
      this.treeShow = false;
      window.sessionStorage.setItem("currentDirectory", JSON.stringify(a));
      window.sessionStorage.setItem("breadcrumb", JSON.stringify(b));
      this.$emit("replace");
    },
    async loadNode(node, resolve) {
      let url;
      let sectionId;
      let subjectId;
      let versionId;
      let dataId;
      let chapterId;
      if (node.level == 0) {
        url =
          this.breadcrumb1.length == 2
            ? "/common/catalog/load/version"
            : this.breadcrumb1.length == 3
            ? "/common/catalog/load/volume"
            : this.breadcrumb1.length == 4
            ? "/common/catalog/load/chapter"
            : "";
        sectionId = this.breadcrumbData.sectionId;
        subjectId = this.breadcrumbData.subjectId;
        versionId =
          this.breadcrumb1.length < 3
            ? node.data
              ? node.data.versionId
              : ""
            : this.breadcrumbData.versionId;
        dataId =
          this.breadcrumb1.length < 4
            ? node.data
              ? node.data.dataId
              : ""
            : this.breadcrumbData.volumeId;
        chapterId = node.data ? node.data.chapterId : "";
      } else {
        url =
          node.data.type == "version"
            ? "/common/catalog/load/volume"
            : node.data.type == "volume"
            ? "/common/catalog/load/chapter"
            : node.data.type == "chapter"
            ? "/common/catalog/load/chapter"
            : "";
        sectionId = node.data.sectionId;
        subjectId = node.data.subjectId;
        versionId = node.data.versionId;
        dataId = node.data.dataId;
        chapterId = node.data.node;
      }
      let a = await this.$ajax.post(url, {
        sectionId: sectionId,
        subjectId: subjectId,
        versionId: versionId,
        chapterId: chapterId,
        dataId: dataId,
      });
      a.map((el) => {
        el.leaf = el.childCount == 0;
      });
      return resolve(a);
    },
    getData() {
      let p = { page: this.pages.pageIndex, size: this.pages.pageSize };
      Object.assign(p, this.search, this.clickData);
      let url =
        this.sortOrder == "最新"
          ? // ? "/server/resource/center/listByDate"
            "/server/third/resource/listByDate"
          : this.sortOrder == "浏览量"
          ? "/server/third/resource/listByDownload"
          : "/server/third/resource/listByFavorite";
      this.$ajax.post(url, p).then((res) => {
        this.data = res.list;
        this.pages.pageAll = res.total;
      });
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    getSearch() {
      this.$ajax.post("/common/load/resource/type").then((res) => {
        this.resourceTypeData = res;
      });
      this.$ajax.post("/common/load/share/year").then((res) => {
        this.yearData = res;
      });
      this.$ajax.post("/common/load/file/type").then((res) => {
        this.fileTypeData = res;
      });
    },
    cancelShare(id) {
      this.$ajax
        .post("/server/resource/common/cancelShare", {
          resourceId: id,
        })
        .then((res) => {
          this.data = this.data.filter((el) => el.resourceId != id);
        });
    },
    downloadFile(url, fileName) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = function (e) {
        //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },

    favorite(d) {
      this.$ajax
        .post("/server/resource/common/favorite", { resourceId: d.resourceId })
        .then((res) => {
          d.isFavorite = "N";
        });
    },
  },
};
</script>

<style scoped>
.vid_box {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0;
}
.v_b_item {
  width: 210px;
  height: 250px;
  padding: 20px 20px 10px;
  box-sizing: border-box;
  box-shadow: 0 0 5px 1px #f1f1f1;
  margin-bottom: 20px;
  margin-right: 23px;
}
.v_b_item:nth-child(4n) {
  margin-right: 0;
}
.v_b_img {
  width: 100%;
  height: 120px;
  margin: 0 auto;
  position: relative;
}
.b_img {
  width: 100%;
  height: 100%;
}
.b_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.b_icon {
  font-size: 40px;
  color: #fff;
}
.v_b_title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 5px;
  line-height: 30px;
  cursor: pointer;
}
.v_b_t {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.b_size {
  color: #409eff;
}
.v_b_time {
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.v_b_menu {
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  color: #333;
  margin-top: 10px;
}
.b_m_p {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.m_p_icon {
  font-size: 20px;
}
.el-icon-star-on {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/page/classroom/index.vue